




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DELETEJOBBYID= createAsyncThunk(
  "deleteJobById/deleteJobById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteJobByIdSlice = createSlice({
  name: "deleteJobByIdSlice",
  initialState: {
    deleteJobById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteJobById: (state) => {
        state.deleteJobById.loading = false
        state.deleteJobById.error = false
        state.deleteJobById.data = []
        state.deleteJobById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEJOBBYID.fulfilled, (state, action) => {
      state.deleteJobById = {
        ...state.deleteJobById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEJOBBYID.pending, (state, action) => {
      state.deleteJobById = {
        ...state.deleteJobById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEJOBBYID.rejected, (state, action) => {
      state.deleteJobById = {
        ...state.deleteJobById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteJobByIdAction = {
    DELETEJOBBYID,
};

export { deleteJobByIdAction };
export default deleteJobByIdSlice.reducer;
export const {setInitialStateOfdeleteJobById} = deleteJobByIdSlice.actions
